<script lang="ts">
  import { fade } from 'svelte/transition'
  import Form from './new/Form.svelte'
  import keywordsStore from '@/stores/keywords.svelte'

  let {
    initialKeywords = [],
    shortCode = ''
  } = $props()

  let keywords = $state(JSON.parse(initialKeywords))
  let allGroupsVisibility = $state({})


  function autoResponderInactive(keyword) {
    return isAutoresponder(keyword) && !keyword.auto_response.active
  }

  function autoResponderStatus(keyword) {
    if (isAutoresponder(keyword)) {
      console.log('in autoResponderStatus', keyword.auto_response)
      return autoResponderInactive(keyword) ? 'Off' : 'On'
    }
  }

  function confirmDelete(keyword) {
    swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true
      },
      confirmed => {
        if (confirmed) {
          keywordsStore.delete(keyword)
            .then(response => {
              let i = keywords.indexOf(keyword)
              if (i > -1) {
                keywords.splice(i, 1)
              }
            })
        }
      })
  }

  function isAutoresponder(keyword) {
    return keyword.keyword_type == 'Autoresponder'
  }

  function showingAllGroups(id) {
    return allGroupsVisibility[id]
  }

  function toggleAllGroups(id) {
    allGroupsVisibility[id] = !allGroupsVisibility[id]
  }
</script>

<div class="KeywordsIndex">
  <Form {shortCode} />

  <table class="separated-rows">
    <thead>
    <tr>
      <th>Keyword</th>
      <th class="shrink">
        Type
      </th>
      <th style="width: 50%">Contacts</th>
      <th class="shrink">Manage</th>
    </tr>
    </thead>

    <tbody>

    {#each keywords as keyword (keyword.to_param)}
      <tr transition:fade>
        <td>
          <a href="/keywords/{keyword.to_param}/edit">
            {keyword.keyword}
          </a>
        </td>
        <td>
          {keyword.keyword_type}
          <span class:d-none={!isAutoresponder(keyword)}
                class="autoresponder-status"
                data-status={autoResponderStatus(keyword)}></span>
        </td>

        <td>
          {#if keyword.retain_new_contacts}
            <div class="flex-row">
              <div class="cell-0">
                <span class="icon icon--contacts-saved"></span>
              </div>
              <div class="cell-1">

                <div class="group-labels" class:active={showingAllGroups(keyword.to_param)}>
                  Contacts are saved to

                  {#if !keyword.add_to_groups.length}
                    <div class="label label--group-name">Account</div>
                  {:else if keyword.add_to_groups.length === 1}
                    <div class="label label--group-name">{keyword.add_to_groups[0].group.name}</div>
                  {:else}
                    {#each keyword.add_to_groups as step (step.id)}
                      <div class="label label--group-name">
                        {step.group.name}
                      </div>
                    {/each}
                    <button type="button" class="group-labels-show-more btn-link"
                            onclick={() => toggleAllGroups(keyword.to_param)}>
                      Show {keyword.add_to_groups.length - 1} more
                    </button>
                  {/if}

                </div>
              </div>
            </div>
          {:else}
            <span class="icon icon--contacts-not-saved"></span>
            Contacts are <strong>not</strong> being saved
          {/if}
        </td>

        <td class="actions">
          <a href="/keywords/{keyword.to_param}/edit">
            Edit
            <span class="icon icon--keywords-edit"></span>
          </a>
          <button type="button" onclick={() => confirmDelete(keyword)} class="btn btn-link">
            Delete
            <span class="icon icon--keywords-delete"></span>
          </button>
        </td>
      </tr>
    {/each}

    </tbody>
  </table>

</div>

<style lang="scss">
  .btn-link {
    color: rgb(94, 186, 50);
    font-size: 1em;
    margin: 0;
  }

  table.separated-rows th,
  table.separated-rows td {
    padding: .5em;
    vertical-align: middle;
  }

  table.separated-rows th:first-child,
  table.separated-rows td:first-child {
    padding-left: 1em;
  }
</style>
